import { IconButton } from "@mui/material";
import { ReactComponent as MagicSpinner } from "../Assets/magic-spinner.svg";

const Loader = () => {
  return (
    <IconButton
      sx={{
        animation: "spin 2s linear infinite",
      }}
    >
      <MagicSpinner  />
    </IconButton>
  );
};

export default Loader;
